import React, {useState} from 'react'
import PDFViewer from './PDFViewer';
import { useNavigate, useLocation } from 'react-router-dom';


const Evidence = ({evidences}) => {
    const [showPDF, setShowPDF] = useState(false);
    const [pdfPath, setPdfPath] = useState('');

    const handleClick = (origPdfPath) => {
      const decodedPath = decodeURIComponent(origPdfPath);
      const ext = decodedPath.split('.').pop().toLowerCase(); // 拡張子を取得

      if (ext === "pdf") {
          setPdfPath(decodedPath);
          setShowPDF(true);
      } else if (ext === "htm" || ext === "html") {
          window.open(decodedPath, '_blank', 'noopener,noreferrer'); // 新しいタブで開く
      } else {
          console.warn(`Unsupported file type: ${ext}`);
      }
    };

    return (
      <div className="doc-info-container">
        <div className="doc-info">
          {
            evidences.map(elem => (
              <div key={elem.pdf_path} >
                <div 
                    onClick={() => handleClick(elem.pdf_path)}
                    className="hover:bg-gray-200 cursor-pointer px-2 py-1 rounded"
                >
                    [{ elem.company_name }: {elem.pdf_name }]
                </div>
            </div>

            ))
          }
        </div>
        <div></div>
        {showPDF && 
          <div className='relative'>
            <button 
            className="absolute right-6 p-1 rounded-full hover:bg-gray-200 transition duration-200 text-black height-[25px]"
            onClick={() => setShowPDF(false)}
              >×</button>
            <PDFViewer pdfPath={pdfPath} />
          </div>}
      </div>
    )
}

export default Evidence
